/**
 * Array of versions
 */
export default ['3.0.1', '3.0.2', '3.1', '3.2', '3.3', '3.4', '3.5', '3.6', '3.7', '3.8', '3.9', '4.0', '4.1', '4.2', '5.0', '5.1', '5.2', '5.4', '5.5', '5.6', '5.7', '5.8', '5.9'];
